import getSymbolFromCurrency from 'currency-symbol-map';

export const formatMoney = (x: { value: string; currency: string }): string => {
    return `${getSymbolFromCurrency(x.currency)}${x.value} ${x.currency}`
}